// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"000c6169","106":"67055c78","126":"f263fa27","133":"ec53239c","453":"bd7e5a6e","497":"c6814083","542":"130f0afc","776":"9ece37bd"}[chunkId] + ".chunk.js";
};